import { defineMessages } from 'react-intl';

export default defineMessages({
  create: {
    id : 'event_trigger.create.title',
    defaultMessage: 'Create'
  },
  read: {
    id : 'event_trigger.read.title',
    defaultMessage: 'Read'
  },
  update: {
    id : 'event_trigger.update.title',
    defaultMessage: 'Update'
  },
  delete: {
    id : 'event_trigger.delete.title',
    defaultMessage: 'Delete'
  },
});
